import { Media } from '@/styles';
import styled from '@emotion/styled';
import Base, { RoundedButtonProps } from './Base';

const Home = ({ active, ...props }: RoundedButtonProps): JSX.Element => {
  return (
    <Base {...props}>
      {active ? (
        <Svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M21.6954 1.50322C21.2454 1.05329 20.635 0.800537 19.9986 0.800537C19.3622 0.800537 18.7519 1.05329 18.3018 1.50322L1.50183 18.3032C1.06465 18.7559 0.822748 19.3621 0.828216 19.9914C0.833684 20.6207 1.08609 21.2226 1.53107 21.6676C1.97605 22.1126 2.578 22.365 3.20727 22.3704C3.83654 22.3759 4.44279 22.134 4.89543 21.6968L5.59863 20.9936V36.8C5.59863 37.4365 5.85149 38.047 6.30158 38.4971C6.75166 38.9472 7.36211 39.2 7.99863 39.2H12.7986C13.4352 39.2 14.0456 38.9472 14.4957 38.4971C14.9458 38.047 15.1986 37.4365 15.1986 36.8V32C15.1986 31.3635 15.4515 30.7531 15.9016 30.303C16.3517 29.8529 16.9621 29.6 17.5986 29.6H22.3986C23.0352 29.6 23.6456 29.8529 24.0957 30.303C24.5458 30.7531 24.7986 31.3635 24.7986 32V36.8C24.7986 37.4365 25.0515 38.047 25.5016 38.4971C25.9517 38.9472 26.5621 39.2 27.1986 39.2H31.9986C32.6352 39.2 33.2456 38.9472 33.6957 38.4971C34.1458 38.047 34.3986 37.4365 34.3986 36.8V20.9936L35.1018 21.6968C35.5545 22.134 36.1607 22.3759 36.79 22.3704C37.4193 22.365 38.0212 22.1126 38.4662 21.6676C38.9112 21.2226 39.1636 20.6207 39.1691 19.9914C39.1745 19.3621 38.9326 18.7559 38.4954 18.3032L21.6954 1.50322Z"
            fill="#4859A4"
          />
        </Svg>
      ) : (
        <Svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M21.6954 1.50322C21.2454 1.05329 20.635 0.800537 19.9986 0.800537C19.3622 0.800537 18.7519 1.05329 18.3018 1.50322L1.50183 18.3032C1.06465 18.7559 0.822748 19.3621 0.828216 19.9914C0.833684 20.6207 1.08609 21.2226 1.53107 21.6676C1.97605 22.1126 2.578 22.365 3.20727 22.3704C3.83654 22.3759 4.44279 22.134 4.89543 21.6968L5.59863 20.9936V36.8C5.59863 37.4365 5.85149 38.047 6.30158 38.4971C6.75166 38.9472 7.36211 39.2 7.99863 39.2H12.7986C13.4352 39.2 14.0456 38.9472 14.4957 38.4971C14.9458 38.047 15.1986 37.4365 15.1986 36.8V32C15.1986 31.3635 15.4515 30.7531 15.9016 30.303C16.3517 29.8529 16.9621 29.6 17.5986 29.6H22.3986C23.0352 29.6 23.6456 29.8529 24.0957 30.303C24.5458 30.7531 24.7986 31.3635 24.7986 32V36.8C24.7986 37.4365 25.0515 38.047 25.5016 38.4971C25.9517 38.9472 26.5621 39.2 27.1986 39.2H31.9986C32.6352 39.2 33.2456 38.9472 33.6957 38.4971C34.1458 38.047 34.3986 37.4365 34.3986 36.8V20.9936L35.1018 21.6968C35.5545 22.134 36.1607 22.3759 36.79 22.3704C37.4193 22.365 38.0212 22.1126 38.4662 21.6676C38.9112 21.2226 39.1636 20.6207 39.1691 19.9914C39.1745 19.3621 38.9326 18.7559 38.4954 18.3032L21.6954 1.50322Z"
            fill="#BEC6E4"
          />
        </Svg>
      )}
    </Base>
  );
};

const Svg = styled.svg`
  height: auto;
  @media ${Media.sm} {
    width: 1.5rem;
  }
  @media ${Media.md} {
    width: 2.5rem;
  }
  @media ${Media.lg} {
    width: 2.5rem;
  }
`;

Home.defaultProps = {
  active: false,
};

export default Home;
